import { PersonalExpenseType } from '/@/modules/liability/enums/PersonalExpenseType';
import { DocumentSubType } from '/@/modules/document/enums/DocumentSubType';
import Lang from '/@/modules/core/app/services/Lang';

export class PersonalExpenseLiabilityMeta {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  nameOfIssuer;

  /**
   * @var {boolean}
   */
  isRecurring;

  /**
   * @var {string}
   */
  rentalResidenceType;

  /**
   * @var {string}
   */
  vehicleCategory;

  constructor(model = {}) {
    this.type = model.type;
    this.nameOfIssuer = model.nameOfIssuer;
    this.isRecurring = model.isRecurring ?? false;
    this.rentalResidenceType = model.rentalResidenceType;
    this.vehicleCategory = model.vehicleCategory;
  }

  /**
   * @return {boolean}
   */
  get isRent() {
    return this.type === PersonalExpenseType.RENT.key;
  }

  /**
   * @return {boolean}
   */
  get isCarLease() {
    return this.type === PersonalExpenseType.CAR_LEASE.key;
  }

  /**
   * @return {boolean}
   */
  get isRentOrLease() {
    return (
      this.type === PersonalExpenseType.CAR_LEASE.key || this.type === PersonalExpenseType.RENT.key
    );
  }

  /**
   * @return {string}
   */
  get uploadDescription() {
    return this.isCarOrRentExpense ? Lang.t('liability.upload-lease-agreement') : Lang.t('liability.upload-bill');
  }

  /**
   * @return {string}
   */
  get documentSubType() {
    return this.isCarOrRentExpense
      ? DocumentSubType.LIABILITY_LEASE.key
      : DocumentSubType.LIABILITY_BILL.key;
  }

  /**
   * @return {string}
   */
  get placeholderDescription() {
    if (this.isOtherPersonalExpense) {
      return Lang.t('core.specify');
    }
    if (this.isCarLease) {
      return Lang.t('liability.leaser');
    }
    return Lang.t('asset.issued-by');
  }

  /**
   * @returns {boolean}
   */
  get isCarOrRentExpense() {
    return this.isRent || this.isCarLease;
  }

  /**
   * @returns {boolean}
   */
  get isOtherPersonalExpense() {
    return this.type === PersonalExpenseType.OTHER.key;
  }

  /**
   * @returns {boolean}
   */
  get isUtilitiesExpense() {
    return this.type === PersonalExpenseType.UTILITIES.key;
  }

  /**
   * @returns {boolean}
   */
  get isSubscriptionExpense() {
    return this.type === PersonalExpenseType.SUBSCRIPTIONS.key;
  }

  /**
   * @returns {string}
   */
  get title() {
    return PersonalExpenseType.getByKey(this.type).value;
  }
}
